import { Lang } from '@/store/types';
const getters = {
    showLang: (state) => {
        if (state.user.userLang === Lang.system) {
            return state.device.lang;
        }
        return state.user.userLang;
    },
};
export default getters;
